<!-- module legend -->
<mat-card class="full-width card-legend break-inside-avoid mb-20" *ngIf="items && items.length > 0">
    <mat-card-content class="pb-0">
        <div class="legend flex-h">
            <div *ngFor="let band of items" class="legend-block">
                <div class="legend-value flex-h align-items-center justify-content-center" [ngStyle]="{ 'background-color': band.color, 'border': band.borderColor ? '1px solid ' + band.borderColor : 'initial' }">
                    <span *ngIf="band.bandMin != null && band.bandMax != null">{{ band.bandMin | number:'1.0-1' }} - {{ band.bandMax | number:'1.0-1' }}</span>
                    <span *ngIf="!!band.bandValueTextKey">{{ band.bandValueTextKey | translate }}</span>
                    <span *ngIf="!!band.bandDescriptionKey">&nbsp;[{{ band.bandDescriptionKey | translate }}]</span>
                </div>
                <span>{{ band.nameKey | translate }}</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>